import React, { useEffect, useState } from 'react';
import '../../styles/gymdash.css';
import { services } from '../../apis';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useSelector, useDispatch } from 'react-redux';
import {
	fetchGymQuestions,
	setPage,
	setType,
	setDifficulty,
	setBookmark,
	setTags,
	setName,
	setCourseIdForFilter,
	setQuestionSource,
	addBookmark,
	removeBookmark,
	resetAllFilter, fetchWebDevGymQuestions, fetchGymConceptualQuestions, getRevisionSheets,setRevisionSheetId, fetchRevisionSheetQuestions
} from '../../redux/gym/gymSlice';
import Loader from '../../components/Loader';
import {
	FiArrowRight,
	FiAward,
	FiTarget,
	FiZap,
	FiCheck,
	FiSearch,
	FiFilter,
	FiBookmark,
} from 'react-icons/fi';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { GrPowerReset } from 'react-icons/gr';
import { RiCloseCircleFill } from 'react-icons/ri';
import { fetchAllTagsList } from '../../redux/user/userSlice';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { EventAvailable } from '@mui/icons-material';
import RevisionSheetCard from '../../components/revisionSheetCard/RevisionSheetCard';

const GymDash = () => {
	const dispatch = useDispatch();
	const [componentArray, setComponentArray] = useState<number[]>([1, 0, 0]);

	const msg = [
		'Wow ! You have a great start, continue solving...',
		'Wow ! You\'ve Solved quite a lot of Questions',
	];

	const [section, setSection] = useState(0);

	const sectionArray = ['questions', 'recording', 'concept video'];

	const componentToggler = (num: number) => {
		const temp = [...componentArray];
		for (let i = 0; i < 3; i++) temp[i] = num === i ? 1 : 0;
		console.log(temp);
		setComponentArray([...temp]);
		setSection(num);
	};

	const gymState = useSelector((state: any) => state.gym);

	const {
		filteredData,
		solvedStatus,
		difficulty,
		name,
		tags,
		page,
		bookmarked,
		gymloading,
		courseId,
		questionSource,
		filterCourseName,
		revisionSheets,
		revisionSheetId
	} = gymState;

	const userState = useSelector((state: any) => state.user);

	const { courseList, topicTags } = userState;

	const [solved, setSolved] = useState(0);

	const [totalPageCount, setTotalPageCount] = useState(1);
	const [isFilterActive, setIsFilterActive] = useState(false);

	// const [age, setAge] = React.useState('');

	const handleTagsChange = (event: SelectChangeEvent) => {
		console.log(event.target.value);
		dispatch(setTags(event.target.value));
	};

	useEffect(() => {
		if (filteredData !== null) {
			setSolved(filteredData.solvedCount >= 200 ? 1 : 0);
			const totalpages = Math.ceil(filteredData.totalCount / 20);
			setTotalPageCount(totalpages);
		}
	}, [filteredData]);

	useEffect(()=>{
		if(revisionSheets==null){
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			dispatch(getRevisionSheets())
		}
	},[revisionSheets])

	useEffect(() => {
		let dif = false;
		for (let i = 0; i < 3; i++) {
			dif = dif || difficulty[i];
		}
		if (
			solvedStatus !== 2 ||
			courseId !== '' ||
			bookmarked ||
			tags.length > 0 ||
			dif ||
			questionSource !== ''
		) {
			setIsFilterActive(true);
		} else {
			setIsFilterActive(false);
		}

		if(revisionSheetId !='all_ques'){
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			dispatch(fetchRevisionSheetQuestions());
		}
		else if (componentArray[0] === 1) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			dispatch(fetchGymQuestions());
		} else if (componentArray[1] === 1) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			dispatch(fetchWebDevGymQuestions());
		} else if (componentArray[2] === 1) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			dispatch(fetchGymConceptualQuestions());
		}


	}, [
		page,
		solvedStatus,
		difficulty,
		bookmarked,
		tags,
		courseId,
		questionSource,
		componentArray,
	]);

	useEffect(() => {
		if (topicTags.length === 0) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			dispatch(fetchAllTagsList());
		}
	}, [topicTags]);

	const selectRevisionSheet = (sheetId:string)=>{
		if(sheetId===revisionSheetId){
			return;
		}
		if( sheetId==="all_ques"){
			dispatch(setRevisionSheetId("all_ques"))
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			dispatch(fetchGymQuestions());
		}else{
			dispatch(
				setRevisionSheetId(sheetId),
			);
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			dispatch(fetchRevisionSheetQuestions())
		}
	}

	const colorDIFFMap = (diff: string): any => {
		const color = [
			{
				color: '#EF574C',
				bg: '#FDE6E4',
			},
			{
				color: '#F0B416',
				bg: 'rgba(253, 242, 214, 0.5)',
			},
			{
				color: '#12B76A',
				bg: '#E3FFED',
			},
		];
		if (diff === 'HARD') {
			return color[0];
		} else if (diff === 'MEDIUM') {
			return color[1];
		} else if (diff === 'EASY') {
			return color[2];
		}
	};

	const handlePaginationChange = (event: any) => {
		dispatch(setPage(event.target.innerText));
	};

	const keyPress = (e: any) => {
		// e.preventDefault();
		if (e.keyCode == 13) {
			e.preventDefault();
			// console.log(e.target.value)
			dispatch(setName(e.target.value));
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			dispatch(fetchGymQuestions());
		}
	};

	const clearNamedFilter = () => {
		dispatch(setName(''));
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		dispatch(fetchGymQuestions());
	};

	const bookmarkThisQuestion = async (questionID: string) => {
		const input = {
			questionId: questionID,
			type: componentArray.findIndex(el => el === 1),
		};
		console.log(input);
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		dispatch(addBookmark(input));
	};

	const removebookmarkFromThisQuestion = async (questionID: string) => {

		const input = {
			questionId: questionID,
			type: componentArray.findIndex(el => el === 1),
		};
		console.log(input);

		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		dispatch(removeBookmark(input));
	};

	return (
		<div className={'gym-dash'}>
			<div className={'gym-content'}>
				<h1>Welcome to The Gym</h1>
				<ul className={'gym-content-switch'}>
					<li
						className={componentArray[0] === 1 ? 'active' : ''}
						onClick={() => componentToggler(0)}
					>
						Questions
					</li>
					<li
						className={componentArray[1] === 1 ? 'active' : ''}
						onClick={() => componentToggler(1)}
					>
						Web Development
					</li>
					<li
						className={componentArray[2] === 1 ? 'active' : ''}
						onClick={() => componentToggler(2)}
					>
						Conceptual Questions
					</li>
				</ul>
				<div className={'gym-msg'}>
					{msg[solved]}
					{!gymloading && filteredData !== null ? (
						<p className={'gym-score'}>
							{filteredData.solvedCount} /
							{filteredData.totalCount} solved
							<span className={'gym-msg-check'}>
								<FiCheck />
							</span>
						</p>
					) : (
						<Loader />
					)}
				</div>
				<OwlCarousel className='owl-theme gym-revision-sheets owl-drag owl-grab' dots={false} margin={10} nav>
					{revisionSheets && revisionSheets.length!=0 && <RevisionSheetCard selectRevisionSheet={selectRevisionSheet} data={{name:"All Questions", id:"all_ques"}} ind={0} active={revisionSheetId==="all_ques"}/>}
					{revisionSheets && revisionSheets.map((sn:any,i:number)=><RevisionSheetCard selectRevisionSheet={selectRevisionSheet} data={sn} ind={i+1} active={revisionSheetId===sn.id}  />)}
				
				</OwlCarousel>
				{/* <ul className="gym-revision-sheets" >
				<RevisionSheetCard selectRevisionSheet={selectRevisionSheet} data={{name:"All Questions", id:'all_ques'}} ind={0} />
					{revisionSheets && revisionSheets.map((sn:any,i:number)=><RevisionSheetCard selectRevisionSheet={selectRevisionSheet} data={sn} ind={i+1} />)}
				</ul> */}
				<ul className={'gym-questions'}>
					{!gymloading && filteredData !== null ? (
						filteredData.questions.map((el: any, index: number) => {
							return (
								<li
									key={`${el.id}/${
										el.bookmarked
											? 'bookmarked'
											: 'notbookmark'
									}`}
									className={'question'}
								>
									<div className={'question-info'}>
										<div className={'question-details'}>
											<h4>{el.title}</h4>
											{/*{el.tags.length > 0 ? (*/}
											{/*	<ul className={'topic-tags'}>*/}
											{/*		{el.tags.map(*/}
											{/*			(tags: any) => (*/}
											{/*				<li*/}
											{/*					key={tags.id}*/}
											{/*					className={*/}
											{/*						'tag'*/}
											{/*					}*/}
											{/*				>*/}
											{/*					{tags.name}*/}
											{/*				</li>*/}
											{/*			)*/}
											{/*		)}*/}
											{/*	</ul>*/}
											{/*) : null}*/}
											<ul className={'question-meta'}>
												<li>
													<FiZap />
													<span
														className={'difficulty'}
														style={{
															color: colorDIFFMap(
																el.difficulty,
															).color,
															backgroundColor:
															colorDIFFMap(
																el.difficulty,
															).bg,
														}}
													>
														{el.difficulty}
													</span>
												</li>
												<li>
													<FiTarget /> Max Score:{' '}
													{el.score} Points
												</li>
												<li>
													<FiAward />
													Your Score:{' '}
													{el.user_score !== null
														? el.user_score
														: 0}{' '}
													Points
												</li>
											</ul>
										</div>
										<div className={'question-btn'}>
											<span
												className={`${
													el.bookmarked
														? 'bookmarked'
														: 'bookmark'
												}`}
												onClick={() => {
													if (!el.bookmarked) {
														bookmarkThisQuestion(
															el.id,
														);
													} else {
														removebookmarkFromThisQuestion(
															el.id,
														);
													}
												}}
											>
												<FiBookmark />
											</span>
											<button
												className={`${
													el.solved
														? 'question-solved-btn'
														: 'question-solve-btn'
												}`}
												onClick={() => {
													if (componentArray[0] == 1) {
														window.open(
															`${window.origin}/idle?question=${el.id}`,
															'_blank',
														);
													} else if (componentArray[1] == 1) {
														window.open(
															`${window.origin}/web-idle?question=${el.id}`,
															'_self',
														);
													} else {
														window.open(
															`${window.origin}/gym-aptitude?questionId=${el.id}`,
															'_blank',
														);
													}
												}
												}
											>
												{' '}
												{el.solved ? (
													<>Solved</>
												) : (
													<>
														Start Solving
														<FiArrowRight />
													</>
												)}
											</button>
										</div>
									</div>
								</li>
							);
						})
					) : (
						<Loader />
					)}
				</ul>
				{!gymloading ? (<div className={'pagination'}>
					<Pagination
						count={totalPageCount}
						defaultPage={page}
						siblingCount={2}
						boundaryCount={2}
						onChange={handlePaginationChange}
						// renderItem={(item) => (
						// 	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
						// 	//@ts-ignore
						// 	<PaginationItem
						// 		components={{
						// 			previous: <span>Previous</span>,
						// 			next: <span>Next</span>,
						// 		}}
						// 		{...item}
						// 	/>
						// )}
					/>
				</div>) : null}
			</div>
			<div className={'gym-filter'}>
				<div className={'search-module'}>
					<FiSearch />
					<input
						className={'search-module-input'}
						placeholder={'Search any question'}
						value={name}
						onChange={(e) => {
							dispatch(setName(e.target.value));
							if (e.target.value === '') {
								keyPress(e);
							}
						}}
						onKeyDown={(e) => keyPress(e)}
					/>
					{name !== '' ? (
						<RiCloseCircleFill onClick={clearNamedFilter} />
					) : null}
				</div>
				<div className={'filter-options'}>
					<div className={'filter-head'}>
						<span>
							<FiFilter />
						</span>
						<p>
							Filter {sectionArray[section]}
							{isFilterActive ? (
								<button
									className={'reset-all-filters'}
									onClick={() => {
										dispatch(resetAllFilter());
									}}
								>
									<GrPowerReset />
								</button>
							) : null}
						</p>
					</div>
					{/*UNDER DEVELOPMENT ----------------------- */}
					<div className={'filter-dropdown'}>
						<p>
							module{' '}
							{filterCourseName !== '' ? (
								<button
									onClick={() => {
										const id = '';
										const name = '';
										dispatch(
											setCourseIdForFilter({ id, name }),
										);
									}}
								>
									reset
								</button>
							) : null}
						</p>
						{courseList !== null ? (
							<Select
								id={'module-option'}
								className={'tag-dropdown'}
								value={filterCourseName}
								label='Course'
								// name=""
								onChange={async (event) => {
									console.log(
										'course filter',
										event.target.name,
									);
									const id = event.target.value;
									const name = id;
									dispatch(
										setCourseIdForFilter({ id, name }),
									);
									// if (event.target.value === 'default') {
									// 	// console.log(event.target.)
									// 	const name = 'default';
									// 	id = '';
									// 	dispatch(
									// 		setCourseIdForFilter({ id, name })
									// 	);
									// } else {
									//
									// }
								}}
							>
								{/*<MenuItem*/}
								{/*	key={''}*/}
								{/*	value={'default'}*/}
								{/*>*/}
								{/*	Select Module*/}
								{/*</MenuItem>*/}
								{courseList.map((el: any, index: number) => (
									<MenuItem
										key={el.id}
										value={el.id}
									>
										{el.title}
									</MenuItem>
								))}
							</Select>
						) : null}
					</div>
					<div className={'filter-dropdown'}>
						<p>
							Topic{' '}
							{tags.length > 0 ? (
								<button
									onClick={() => {
										dispatch(setTags([]));
									}}
								>
									reset
								</button>
							) : null}
						</p>
						<Select
							value={tags}
							label='Tags'
							onChange={handleTagsChange}
							multiple={true}
							className={'tag-dropdown'}
						>
							{topicTags.map((el: any, index: number) => (
								<MenuItem
									key={el.id}
									value={el.name}
								>
									{el.name}
								</MenuItem>
							))}
						</Select>
					</div>
					<div className={'filter-tags'}>
						<p>Status</p>
						<ul>
							<li
								className={`${
									solvedStatus === 1 ? 'active' : ''
								}`}
								onClick={() => {
									if (solvedStatus === 1)
										dispatch(setType(2));
									else dispatch(setType(1));
								}}
							>
								Solved
							</li>
							<li
								className={`${
									solvedStatus === 0 ? 'active' : ''
								}`}
								onClick={() => {
									if (solvedStatus === 0)
										dispatch(setType(2));
									else dispatch(setType(0));
								}}
							>
								Unsolved
							</li>
							<li
								className={`${bookmarked ? 'active' : ''}`}
								onClick={() => {
									if (bookmarked)
										dispatch(setBookmark(false));
									else dispatch(setBookmark(true));
								}}
							>
								Bookmarked
							</li>
						</ul>
					</div>
					<div className={'filter-tags'}>
						<p>Level</p>
						<ul>
							<li
								className={`${difficulty[0] ? 'active' : ''}`}
								onClick={() => {
									if (difficulty[0])
										dispatch(setDifficulty(0));
									else dispatch(setDifficulty(0));
								}}
							>
								Easy
							</li>
							<li
								className={`${difficulty[1] ? 'active' : ''}`}
								onClick={() => {
									if (difficulty[1])
										dispatch(setDifficulty(1));
									else dispatch(setDifficulty(1));
								}}
							>
								Medium
							</li>
							<li
								className={`${difficulty[2] ? 'active' : ''}`}
								onClick={() => {
									if (difficulty[2])
										dispatch(setDifficulty(2));
									else dispatch(setDifficulty(2));
								}}
							>
								Hard
							</li>
						</ul>
					</div>

					{/*UNDER DEVELOPMENT----------------------*/}
					<div className={'filter-tags'}>
						<p>Question Type</p>
						<ul>
							<li
								className={`${
									questionSource === 'modular' ? 'active' : ''
								}`}
								onClick={() => {
									if (questionSource === 'modular')
										dispatch(setQuestionSource(''));
									else dispatch(setQuestionSource('modular'));
								}}
							>
								Assignment
							</li>
							<li
								className={`${
									questionSource === 'gym' ? 'active' : ''
								}`}
								onClick={() => {
									if (questionSource === 'gym')
										dispatch(setQuestionSource(''));
									else dispatch(setQuestionSource('gym'));
								}}
							>
								Practice Questions
							</li>
						</ul>
					</div>
					{/*<div className={'filter-tags'}>*/}
					{/*	<p>Type</p>*/}
					{/*	<ul>*/}
					{/*		<li*/}
					{/*			className={`${*/}
					{/*				questionCategory === 'DSA' ? 'active' : ''*/}
					{/*			}`}*/}
					{/*			onClick={() => {*/}
					{/*				if (questionCategory === 'DSA')*/}
					{/*					dispatch(setQuestionCategory(''));*/}
					{/*				else dispatch(setQuestionCategory('DSA'));*/}
					{/*			}}*/}
					{/*		>*/}
					{/*			Data Structures*/}
					{/*		</li>*/}
					{/*		<li*/}
					{/*			className={`${*/}
					{/*				questionCategory === 'WEB' ? 'active' : ''*/}
					{/*			}`}*/}
					{/*			onClick={() => {*/}
					{/*				if (questionCategory === 'WEB')*/}
					{/*					dispatch(setQuestionCategory(''));*/}
					{/*				else dispatch(setQuestionCategory('WEB'));*/}
					{/*			}}*/}
					{/*		>*/}
					{/*			Web Development*/}
					{/*		</li>*/}
					{/*	</ul>*/}
					{/*</div>*/}
				</div>
			</div>
		</div>
	);
};

export default GymDash;
